import React from "react";
import styles from "./index.module.scss";
import { BiUndo } from "react-icons/bi";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

interface EvaluateHeaderProps {
    title: string;
}

export default function EvaluateHeader({ title }: EvaluateHeaderProps) {
    const history = useHistory();

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>{title}</h1>

            <Button className={styles.back} onClick={() => history.goBack()}>
                <BiUndo size={16} /> 返回
            </Button>
        </div>
    );
}
